// filepath: /d:/Projetos Git/Seguro-turismo-front/src/Pages/QrCodePage/index.js
import React from 'react';
import { useParams } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import { Box, Button, Container, Typography } from '@mui/material';
import './styles.css';


export const QrCodePage = () => {
    const { id } = useParams();

    // Verificar se o id está disponível
    if (!id) {
        return <div>Loading...</div>;
    }

    const handleShare = () => {
        if (navigator.share) {
            const canvas = document.getElementById('qrcode');
            if (canvas) {
                canvas.toBlob((blob) => {
                    const file = new File([blob], 'qrcode.png', { type: 'image/png' });
                    navigator.share({
                        files: [file],
                        title: 'QR Code',
                        text: 'Here is your QR code',
                    });
                });
            }
        } else {
            alert('Sharing is not supported on this browser.');
        }
    };

    return (
      <Box className="background">
          <Container maxWidth="sm">
              <Box className="qrcode-container">
                  <Typography variant="h5" gutterBottom>
                      Apresente se necessário
                  </Typography>
                  <QRCodeCanvas id="qrcode" value={id} size={256} />
                  <Box mt={2}>
                      <Button variant="contained" color="primary" onClick={handleShare}>
                          Compartilhar
                      </Button>
                  </Box>
              </Box>
          </Container>
      </Box>
    );
};